import type { SVGProps } from 'react';
import { directionalIcons, iconPaths, type IconName } from './paths';
import s from './Icon.module.css';

export type { IconName };
export { iconPaths };

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'dangerouslySetInnerHTML' | 'children'> {
  name: IconName;
  size?: 'sm' | 'md';
  /** A label makes the icon meaningful to screen readers; without one it is decorative. */
  label?: string;
}

/**
 * The prototype's line icons. "back"/"fwd" (and other directional icons)
 * are drawn for right-to-left pages and mirror themselves in left-to-right ones.
 */
export function Icon({ name, size = 'md', label, className, ...rest }: IconProps) {
  const cls = ['ic', size === 'sm' ? 'sm' : '', directionalIcons.has(name) ? s.mirror : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <svg
      className={cls}
      viewBox="0 0 24 24"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true, focusable: false })}
      // Static, trusted path data from paths.ts.
      dangerouslySetInnerHTML={{ __html: iconPaths[name] }}
      {...rest}
    />
  );
}
